var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export default class NavigateEvent extends Event {
    constructor(type, options) {
        const { navigationType, destination } = options, eventInit = __rest(options, ["navigationType", "destination"]);
        super(type, Object.assign({
            bubbles: false,
            cancelable: true,
        }, eventInit));
        this.navigationType = navigationType;
        this.destination = destination;
    }
}
